import { graphql } from 'gql';

export const deleteBimOrderChangeGql = graphql(`
    mutation bimDeleteWorkOrderChange($workOrderChangeId: Long!) {
        bimDeleteWorkOrderChange(workOrderChangeId: $workOrderChangeId) {
            id
            result
            message
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);
